import RenameBillPopoverForm from "@/app/components/bill/RenameBillPopoverForm.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class RenameBillPopover extends VueContentPopover {
    constructor() {
        super({ popoverClass: "rename-bill-popover", fullscreen: false });

        const props = {
            onClose: () => this.hide(),
        };
        this.initComponent(RenameBillPopoverForm, props);
    }
}
